import { UntypedFormGroup } from '@angular/forms';

export function ValidateCheckboxOrderCancel(fg: UntypedFormGroup): { [key: string]: boolean } | null {
  let isChecked = false;
  Object.keys(fg.controls).forEach(key => {
    isChecked += fg.controls[key].value;
  });
  return (isChecked) ? null : {ValidateCheckboxOrderCancel: true};
}
